var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "empresa_icono_para_tarjeta_JPA",
    "data-name": "empresa icono para tarjeta JPA",
    d: "M3.753,17.76c-.164-.1-.11-11.79,0-11.861s5.733-.062,5.771,0-.063,2.672,0,2.718,6.027-.068,6.067,0,.109,9.01,0,9.143S3.917,17.862,3.753,17.76Zm.888-.988H6.195v-1.73H4.641Zm0-2.718H6.195v-1.73H4.641Zm0-2.718H6.195V9.605H4.641Zm0-2.718s1.522.046,1.554,0a12.253,12.253,0,0,0,0-1.73,8.272,8.272,0,0,0-1.554,0C4.586,6.938,4.641,8.617,4.641,8.617Zm2.442,8.155H8.636v-1.73H7.083Zm0-2.718H8.636v-1.73H7.083Zm0-2.718H8.636V9.605H7.083Zm0-2.718H8.636V6.887H7.083Zm2.442,8.155H14.7V9.605H9.524v1.73h1.184v.988H9.524v1.73h1.184v.988H9.524Zm2.737-4.448a.817.817,0,0,1,0-.988.624.624,0,0,1,.888,0,.817.817,0,0,1,0,.988A.624.624,0,0,1,12.262,12.323Zm0,2.718a.817.817,0,0,1,0-.988.624.624,0,0,1,.888,0,.817.817,0,0,1,0,.988A.624.624,0,0,1,12.262,15.042Z",
    transform: "translate(-3.65 -5.849)",
    fill: " #001e6c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.4cd2a74aca0605cc105b81da2255767f.svg";
export { ForwardRef as ReactComponent };